import { Type } from 'class-transformer';
import { BoardApprovalProcessesResultDto } from '../../shared-acc-board-approval-module/_models/board-approval-processes-result-dto';
import { BoardApprovalItemResultDto } from '../../shared-acc-board-approval-module/_models/board-approval-item-result-dto';

export class BoardApprovalQueueResultDto {
    @Type(() => BoardApprovalProcessesResultDto)
    boardApprovalProcesses: Array<BoardApprovalProcessesResultDto>;

    @Type(() => BoardApprovalItemResultDto)
    boardRequests: Array<BoardApprovalItemResultDto>;
}
